import logo from "../assets/img/logo/logo.png";
import wLogo from "../assets/img/logo/w_logo.png";
import checkIcon from "../assets/img/icons/check_icon.svg";
import checkIcon02 from "../assets/img/icons/check_icon02.svg";
import checkIcon03 from "../assets/img/icons/check_icon03.svg";
import plusIcon from "../assets/img/icons/plus_icon.svg";
import quote from "../assets/img/icons/quote.svg";
import quote02 from "../assets/img/icons/quote02.svg";
import rating from "../assets/img/icons/rating.svg";
import rightArrow from "../assets/img/icons/right-arrow.svg";
import share from "../assets/img/icons/share.svg";

const svgDataUri = (svg) =>
  `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;

const decorativeShape = svgDataUri(`
  <svg xmlns="http://www.w3.org/2000/svg" width="640" height="640" viewBox="0 0 640 640">
    <defs>
      <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="#dbeafe"/>
        <stop offset="100%" stop-color="#bfdbfe"/>
      </linearGradient>
    </defs>
    <rect width="640" height="640" rx="48" fill="url(#g)"/>
    <circle cx="170" cy="180" r="90" fill="#ffffff" fill-opacity="0.45"/>
    <circle cx="470" cy="230" r="120" fill="#93c5fd" fill-opacity="0.45"/>
    <circle cx="320" cy="430" r="150" fill="#60a5fa" fill-opacity="0.35"/>
  </svg>
`);

const brandLogo = (label) =>
  svgDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" width="220" height="80" viewBox="0 0 220 80">
      <rect width="220" height="80" rx="16" fill="#f8fafc"/>
      <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle"
        font-family="Arial, sans-serif" font-size="24" fill="#0f172a">${label}</text>
    </svg>
  `);

const businessIllustration = (theme, width = 1200, height = 900) => {
  const scenes = {
    hero: {
      bgA: "#0f172a",
      bgB: "#1d4ed8",
      panel: "#eff6ff",
      accent: "#f59e0b",
      line: "#93c5fd",
      glow: "#60a5fa",
    },
    registration: {
      bgA: "#f8fafc",
      bgB: "#dbeafe",
      panel: "#ffffff",
      accent: "#2563eb",
      line: "#1e3a8a",
      glow: "#bfdbfe",
    },
    tax: {
      bgA: "#f8fafc",
      bgB: "#dcfce7",
      panel: "#ffffff",
      accent: "#16a34a",
      line: "#14532d",
      glow: "#86efac",
    },
    approvals: {
      bgA: "#fff7ed",
      bgB: "#ffedd5",
      panel: "#ffffff",
      accent: "#ea580c",
      line: "#9a3412",
      glow: "#fdba74",
    },
    compliance: {
      bgA: "#f5f3ff",
      bgB: "#e0e7ff",
      panel: "#ffffff",
      accent: "#4f46e5",
      line: "#312e81",
      glow: "#a5b4fc",
    },
    contact: {
      bgA: "#ecfeff",
      bgB: "#cffafe",
      panel: "#ffffff",
      accent: "#0891b2",
      line: "#164e63",
      glow: "#67e8f9",
    },
  };

  const palette = scenes[theme] || scenes.registration;

  return svgDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 1200 900">
      <defs>
        <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${palette.bgA}"/>
          <stop offset="100%" stop-color="${palette.bgB}"/>
        </linearGradient>
        <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="18" stdDeviation="18" flood-color="#0f172a" flood-opacity="0.12"/>
        </filter>
      </defs>

      <rect width="1200" height="900" rx="36" fill="url(#bg)"/>
      <circle cx="1030" cy="140" r="120" fill="${palette.glow}" fill-opacity="0.3"/>
      <circle cx="940" cy="740" r="180" fill="${palette.glow}" fill-opacity="0.22"/>
      <circle cx="190" cy="120" r="90" fill="#ffffff" fill-opacity="0.18"/>

      <rect x="660" y="110" width="370" height="520" rx="28" fill="${palette.panel}" filter="url(#shadow)"/>
      <rect x="712" y="175" width="145" height="26" rx="13" fill="${palette.glow}"/>
      <rect x="712" y="228" width="250" height="14" rx="7" fill="${palette.line}" fill-opacity="0.18"/>
      <rect x="712" y="258" width="220" height="14" rx="7" fill="${palette.line}" fill-opacity="0.12"/>
      <rect x="712" y="318" width="250" height="120" rx="20" fill="${palette.bgB}"/>
      <path d="M760 387l34 34 76-92" fill="none" stroke="${palette.accent}" stroke-width="18" stroke-linecap="round" stroke-linejoin="round"/>
      <rect x="712" y="475" width="120" height="18" rx="9" fill="${palette.line}" fill-opacity="0.18"/>
      <rect x="712" y="510" width="190" height="18" rx="9" fill="${palette.line}" fill-opacity="0.12"/>
      <rect x="712" y="545" width="155" height="18" rx="9" fill="${palette.line}" fill-opacity="0.12"/>

      <rect x="515" y="465" width="210" height="190" rx="24" fill="${palette.panel}" filter="url(#shadow)"/>
      <rect x="565" y="515" width="110" height="24" rx="12" fill="${palette.accent}" fill-opacity="0.16"/>
      <rect x="555" y="560" width="130" height="14" rx="7" fill="${palette.line}" fill-opacity="0.18"/>
      <rect x="555" y="592" width="90" height="14" rx="7" fill="${palette.line}" fill-opacity="0.12"/>
      <rect x="555" y="624" width="115" height="14" rx="7" fill="${palette.line}" fill-opacity="0.12"/>

      <rect x="160" y="470" width="270" height="220" rx="28" fill="${palette.panel}" filter="url(#shadow)"/>
      <path d="M220 628V540l75-58 75 58v88" fill="${palette.bgB}"/>
      <rect x="254" y="572" width="24" height="56" rx="8" fill="${palette.accent}" fill-opacity="0.32"/>
      <rect x="312" y="572" width="24" height="56" rx="8" fill="${palette.accent}" fill-opacity="0.22"/>
      <rect x="220" y="430" width="110" height="26" rx="13" fill="#ffffff" fill-opacity="0.28"/>

      <rect x="160" y="145" width="360" height="220" rx="30" fill="#ffffff" fill-opacity="0.14"/>
      <rect x="210" y="198" width="110" height="18" rx="9" fill="#ffffff" fill-opacity="0.28"/>
      <rect x="210" y="242" width="230" height="16" rx="8" fill="#ffffff" fill-opacity="0.2"/>
      <rect x="210" y="278" width="190" height="16" rx="8" fill="#ffffff" fill-opacity="0.16"/>
      <rect x="210" y="314" width="145" height="16" rx="8" fill="#ffffff" fill-opacity="0.14"/>
    </svg>
  `);
};

const articleIllustration = (theme, width = 1200, height = 900) => {
  const palette = {
    blue: ["#eff6ff", "#bfdbfe", "#1d4ed8"],
    green: ["#ecfdf5", "#a7f3d0", "#059669"],
    amber: ["#fffbeb", "#fde68a", "#d97706"],
    violet: ["#f5f3ff", "#c4b5fd", "#6d28d9"],
    cyan: ["#ecfeff", "#a5f3fc", "#0891b2"],
  }[theme] || ["#eff6ff", "#bfdbfe", "#1d4ed8"];

  return svgDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 1200 900">
      <rect width="1200" height="900" rx="36" fill="${palette[0]}"/>
      <rect x="72" y="72" width="1056" height="756" rx="30" fill="#ffffff"/>
      <rect x="72" y="72" width="1056" height="280" rx="30" fill="${palette[1]}"/>
      <circle cx="980" cy="170" r="90" fill="#ffffff" fill-opacity="0.28"/>
      <rect x="140" y="430" width="250" height="20" rx="10" fill="${palette[2]}" fill-opacity="0.22"/>
      <rect x="140" y="480" width="740" height="18" rx="9" fill="#94a3b8" fill-opacity="0.36"/>
      <rect x="140" y="518" width="680" height="18" rx="9" fill="#94a3b8" fill-opacity="0.28"/>
      <rect x="140" y="556" width="610" height="18" rx="9" fill="#94a3b8" fill-opacity="0.22"/>
      <rect x="140" y="635" width="170" height="54" rx="27" fill="${palette[2]}"/>
      <rect x="932" y="420" width="120" height="120" rx="24" fill="${palette[1]}"/>
      <rect x="932" y="570" width="120" height="120" rx="24" fill="${palette[2]}" fill-opacity="0.18"/>
    </svg>
  `);
};

const projectIllustration = (theme, width = 1200, height = 900) => {
  const palette = {
    navy: ["#0f172a", "#1e293b", "#38bdf8"],
    emerald: ["#022c22", "#064e3b", "#34d399"],
    copper: ["#431407", "#7c2d12", "#fb923c"],
    slate: ["#111827", "#374151", "#93c5fd"],
  }[theme] || ["#0f172a", "#1e293b", "#38bdf8"];

  return svgDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 1200 900">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${palette[0]}"/>
          <stop offset="100%" stop-color="${palette[1]}"/>
        </linearGradient>
      </defs>
      <rect width="1200" height="900" rx="36" fill="url(#g)"/>
      <rect x="110" y="120" width="980" height="610" rx="36" fill="#ffffff" fill-opacity="0.08"/>
      <rect x="180" y="195" width="390" height="410" rx="28" fill="#ffffff" fill-opacity="0.1"/>
      <rect x="630" y="195" width="320" height="160" rx="24" fill="${palette[2]}" fill-opacity="0.24"/>
      <rect x="630" y="390" width="320" height="215" rx="24" fill="#ffffff" fill-opacity="0.1"/>
      <rect x="230" y="250" width="290" height="16" rx="8" fill="#ffffff" fill-opacity="0.42"/>
      <rect x="230" y="288" width="245" height="16" rx="8" fill="#ffffff" fill-opacity="0.24"/>
      <rect x="230" y="326" width="210" height="16" rx="8" fill="#ffffff" fill-opacity="0.18"/>
      <path d="M250 520l78-112 70 74 110-150" fill="none" stroke="${palette[2]}" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="905" cy="235" r="78" fill="#ffffff" fill-opacity="0.14"/>
      <circle cx="990" cy="640" r="105" fill="${palette[2]}" fill-opacity="0.18"/>
    </svg>
  `);
};

const avatarIllustration = (label, bgA, bgB, accent) =>
  svgDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${bgA}"/>
          <stop offset="100%" stop-color="${bgB}"/>
        </linearGradient>
      </defs>
      <rect width="600" height="600" rx="40" fill="url(#g)"/>
      <circle cx="300" cy="220" r="116" fill="#ffffff" fill-opacity="0.16"/>
      <path d="M180 472c28-76 92-118 120-118s92 42 120 118" fill="#ffffff" fill-opacity="0.2"/>
      <circle cx="300" cy="218" r="86" fill="#ffffff" fill-opacity="0.74"/>
      <path d="M236 228c14-36 44-58 64-58s50 22 64 58c-10 34-34 56-64 56s-54-22-64-56z" fill="${accent}" fill-opacity="0.2"/>
      <text x="300" y="542" text-anchor="middle" font-family="Arial, sans-serif" font-size="96" font-weight="700" fill="#ffffff" fill-opacity="0.9">${label}</text>
    </svg>
  `);

export const LOGO = logo;
export const W_LOGO = wLogo;

export const ABOUT_IMG01 = businessIllustration("registration");
export const ABOUT_IMG02 = businessIllustration("compliance");
export const ABOUT_IMG03 = businessIllustration("tax", 700, 520);
export const ABOUT_IMG_SHAPE01 = decorativeShape;
export const ABOUT_IMG_SHAPE02 = decorativeShape;
export const ABOUT_SHAPE01 = decorativeShape;
export const ABOUT_SHAPE02 = decorativeShape;

export const AVATAR = avatarIllustration("Z", "#1e3a8a", "#2563eb", "#f59e0b");
export const BLOG_AVATAR01 = avatarIllustration("A", "#0f766e", "#14b8a6", "#f59e0b");
export const BLOG_AVATAR02 = avatarIllustration("B", "#7c2d12", "#ea580c", "#fde68a");
export const BLOG_AVATAR03 = avatarIllustration("C", "#3730a3", "#6366f1", "#c4b5fd");
export const BLOG_AVATAR04 = avatarIllustration("D", "#166534", "#22c55e", "#bbf7d0");
export const BLOG_AVATAR05 = avatarIllustration("E", "#1d4ed8", "#60a5fa", "#dbeafe");
export const BLOG_AVATAR06 = avatarIllustration("F", "#9a3412", "#fb923c", "#ffedd5");
export const BLOG_DETAILS01 = articleIllustration("blue");
export const BLOG_DETAILS02 = articleIllustration("green");
export const BLOG_IMG01 = articleIllustration("amber");
export const BLOG_IMG02 = articleIllustration("violet");
export const BLOG_IMG03 = articleIllustration("cyan");

export const BRAND_IMG01 = brandLogo("Client 1");
export const BRAND_IMG02 = brandLogo("Client 2");
export const BRAND_IMG03 = brandLogo("Client 3");
export const BRAND_IMG04 = brandLogo("Client 4");
export const BRAND_IMG05 = brandLogo("Client 5");

export const BREADCRUMB_SHAPE01 = decorativeShape;
export const BREADCRUMB_SHAPE02 = decorativeShape;

export const CHECK_ICON = checkIcon;
export const CHECK_ICON02 = checkIcon02;
export const CHECK_ICON03 = checkIcon03;
export const COMMENT01 = avatarIllustration("C1", "#334155", "#64748b", "#f8fafc");
export const COMMENT02 = avatarIllustration("C2", "#3f3f46", "#71717a", "#f4f4f5");
export const CONTACT_IMG = businessIllustration("contact");
export const CONTACT_SHAPE = decorativeShape;
export const COUNTER_SHAPE01 = decorativeShape;
export const COUNTER_SHAPE02 = decorativeShape;
export const FAQ_IMG01 = businessIllustration("approvals");
export const FAQ_IMG02 = businessIllustration("tax", 700, 520);
export const FAQ_SHAPE02 = decorativeShape;
export const FAQ_SHAPE03 = decorativeShape;

export const H2_BLOG_IMG01 = articleIllustration("blue");
export const H2_BLOG_IMG02 = articleIllustration("green");
export const H2_BLOG_IMG03 = articleIllustration("amber");
export const H2_PROJECT_IMG01 = projectIllustration("navy");
export const H2_PROJECT_IMG02 = projectIllustration("emerald");
export const H2_PROJECT_IMG03 = projectIllustration("copper");
export const H2_SERVICES_IMG01 = businessIllustration("registration");
export const H2_SERVICES_IMG02 = businessIllustration("tax");
export const H2_SERVICES_IMG03 = businessIllustration("compliance");
export const H2_SERVICES_IMG04 = businessIllustration("approvals");
export const H2_TEAM_IMG01 = avatarIllustration("T1", "#1d4ed8", "#3b82f6", "#dbeafe");
export const H2_TEAM_IMG02 = avatarIllustration("T2", "#0f766e", "#14b8a6", "#ccfbf1");
export const H2_TEAM_IMG03 = avatarIllustration("T3", "#7c2d12", "#ea580c", "#ffedd5");
export const H2_TEAM_IMG04 = avatarIllustration("T4", "#6d28d9", "#8b5cf6", "#ede9fe");

export const H3_BLOG_IMG01 = articleIllustration("violet");
export const H3_BLOG_IMG02 = articleIllustration("cyan");
export const H3_BLOG_IMG03 = articleIllustration("green");
export const H3_BLOG_IMG04 = articleIllustration("amber");
export const H3_BLOG_IMG05 = articleIllustration("blue");
export const H3_BLOG_IMG06 = articleIllustration("violet");
export const H3_PROJECT_IMG01 = projectIllustration("slate");
export const H3_PROJECT_IMG02 = projectIllustration("navy");
export const H3_PROJECT_IMG03 = projectIllustration("emerald");
export const H3_PROJECT_IMG04 = projectIllustration("copper");
export const H3_TEAM_IMG01 = avatarIllustration("U1", "#1e40af", "#60a5fa", "#eff6ff");
export const H3_TEAM_IMG02 = avatarIllustration("U2", "#166534", "#4ade80", "#f0fdf4");
export const H3_TEAM_IMG03 = avatarIllustration("U3", "#9a3412", "#fdba74", "#fff7ed");
export const H3_TEAM_IMG04 = avatarIllustration("U4", "#581c87", "#c084fc", "#faf5ff");

export const H4_BLOG_IMG01 = articleIllustration("cyan");
export const H4_BLOG_IMG02 = articleIllustration("amber");
export const H4_BLOG_IMG03 = articleIllustration("green");
export const H4_SERVICES_IMG01 = businessIllustration("registration");
export const H4_SERVICES_IMG02 = businessIllustration("tax");
export const H4_SERVICES_IMG03 = businessIllustration("approvals");
export const H4_SERVICES_IMG04 = businessIllustration("compliance");
export const H4_TEAM_IMG01 = avatarIllustration("V1", "#0f172a", "#334155", "#e2e8f0");
export const H4_TEAM_IMG02 = avatarIllustration("V2", "#134e4a", "#0f766e", "#ccfbf1");
export const H4_TEAM_IMG03 = avatarIllustration("V3", "#713f12", "#f59e0b", "#fef3c7");
export const H4_TEAM_IMG04 = avatarIllustration("V4", "#4c1d95", "#8b5cf6", "#ede9fe");

export const H5_ABOUT_IMG = businessIllustration("compliance");
export const H5_ABOUT_SHAPE02 = decorativeShape;
export const H5_PROJECT_IMG01 = projectIllustration("navy");
export const H5_PROJECT_IMG02 = projectIllustration("emerald");
export const H5_PROJECT_IMG03 = projectIllustration("copper");
export const H5_PROJECT_IMG04 = projectIllustration("slate");
export const H5_PROJECT_IMG05 = projectIllustration("navy");
export const H5_TEAM_IMG01 = avatarIllustration("W1", "#1d4ed8", "#38bdf8", "#f8fafc");
export const H5_TEAM_IMG02 = avatarIllustration("W2", "#0f766e", "#2dd4bf", "#ecfeff");
export const H5_TEAM_IMG03 = avatarIllustration("W3", "#c2410c", "#fb923c", "#fff7ed");
export const H5_TEAM_IMG04 = avatarIllustration("W4", "#6d28d9", "#a78bfa", "#f5f3ff");

export const INNER_ABOUT_IMG05 = businessIllustration("registration");
export const INNER_ABOUT_SHAPE01 = decorativeShape;
export const INNER_ABOUT_SHAPE02 = decorativeShape;
export const INNER_ABOUT_SHAPE03 = decorativeShape;

export const PLUS_ICON = plusIcon;
export const PROJECT_DETAILS01 = projectIllustration("navy");
export const PROJECT_DETAILS02 = projectIllustration("emerald");
export const PROJECT_IMG01 = projectIllustration("copper");
export const PROJECT_IMG02 = projectIllustration("slate");
export const PROJECT_IMG03 = projectIllustration("navy");
export const QUOTE = quote;
export const QUOTE02 = quote02;
export const RATING = rating;
export const RC_POST01 = articleIllustration("blue", 320, 220);
export const RC_POST02 = articleIllustration("amber", 320, 220);
export const RC_POST03 = articleIllustration("green", 320, 220);
export const RC_POST04 = articleIllustration("violet", 320, 220);
export const REQUEST_SHAPE = decorativeShape;
export const RIGHT_ARROW = rightArrow;
export const SERVICES_DETAILS01 = businessIllustration("contact");
export const SERVICES_DETAILS05 = businessIllustration("approvals");
export const SERVICES_IMG01 = businessIllustration("registration");
export const SERVICES_IMG02 = businessIllustration("tax");
export const SERVICES_IMG03 = businessIllustration("compliance");
export const SERVICES_ITEM_SHAPE = decorativeShape;
export const SHARE = share;
export const TEAM_DETAILS_IMG = avatarIllustration("ZD", "#0f172a", "#1d4ed8", "#f59e0b");
export const TEAM_IMG01 = avatarIllustration("M1", "#1d4ed8", "#60a5fa", "#eff6ff");
export const TEAM_IMG02 = avatarIllustration("M2", "#0f766e", "#2dd4bf", "#ecfeff");
export const TEAM_IMG03 = avatarIllustration("M3", "#c2410c", "#fb923c", "#fff7ed");
export const TEAM_IMG04 = avatarIllustration("M4", "#6d28d9", "#a78bfa", "#f5f3ff");
export const TESTIMONIAL_IMG = businessIllustration("contact");
